

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-title/dist/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-models/src/bml/index', 'components/xo-models/src/auth/index', 'components/xo-models/src/user/index', 'components/xo-device-info/dist/index', 'components/xo-beaver/dist/logger'], function ($, angular, squid, template) {

    return angular.module('xo-bml-terms-and-conditions.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xomodel.checkout', 'xomodel.fi', 'xomodel.bml', 'xomodel.auth', 'xomodel.user', 'xo-device-info', 'beaver']).directive('xoBmlTermsAndConditionsPage', function () {

        var linkFn = function linkFn(scope, element, attrs) {
            var $agreeButton = $('#bmlAgreeToTerms');

            var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
                eventer = window[eventMethod],
                data,
                messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

            // Browsers that support postMessage
            if (window.postMessage) {
                /**
                 * Event to listen for post messages sent from PayPal popup window.
                 * Data from PayPal will contains return url and the localised content.
                 */
                eventer(messageEvent, function (event) {
                    data = angular.fromJson(event.data);
                    if (data.action === 'scroll') {

                        if (data.toEnd && !scope.isMobile) {
                            scope.scrollComplete();
                        }
                    } else if (data.action === 'setHeight' && scope.isMobile) {
                        $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
                    }
                }, false);
            }

            $agreeButton.click(function (event) {
                event.preventDefault();
                scope.handleAgreeToTermsClick();
            });
        };

        return {
            template: template,
            link: linkFn,

            controller: function controller($scope, $populate, $rootScope, $state, $CheckoutPayeeModel, $BillingAddressesModel, $CheckoutCartModel, $CheckoutSessionModel, $AuthModel, $CheckoutAppDataModel, $BMLApplicationModel, $BMLStateHandler, $PatchPhoneModel, $DeviceInfo, $logger) {

                if ($scope.$parent && $scope.$parent.bml) {
                    $scope.bml = $scope.$parent.bml;
                    $scope.bmlApply = $scope.$parent.bmlApply;
                    $scope.bmlComplete = $scope.$parent.bmlComplete;
                }
                $populate($scope, {
                    auth: $AuthModel.instance(),
                    payee: $CheckoutPayeeModel.instance($rootScope.token),
                    billingAddresses: $BillingAddressesModel.instance(),
                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    $scope.patchPhoneModel = new $PatchPhoneModel();
                    $scope.patchPhoneModel.token = $scope.token;

                    if ($scope.$parent && $scope.$parent.bml) {
                        var bmlData = {
                            reviewUrl: $scope.$parent.reviewUrl,
                            bml: $scope.bml,
                            bmlApply: $scope.bmlApply,
                            bmlComplete: $scope.bmlComplete,
                            checkoutSession: $scope.checkoutSession,
                            auth: $scope.auth,
                            purchase: $scope.checkoutCart.purchase,
                            patchPhone: $scope.patchPhoneModel,
                            billingAddresses: $scope.billingAddresses,
                            merchant: $scope.checkoutAppData.merchant,
                            merchantId: $scope.payee.merchant.id
                        };

                        $scope.bmlStateHandler = new $BMLStateHandler(bmlData);
                    }
                });

                $scope.init = function () {
                    $scope.token = $rootScope.token;
                    $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
                    $('.paypalHeader').removeClass('span14');
                    $('.paypalHeader').addClass('span24');
                    $('.paypalHeader').addClass('headerBar');
                    $('.footerWrapper').addClass('hide');
                    $scope.isMobile = $DeviceInfo.isMobile();
                    $scope.isMiniBrowser = $rootScope.miniBrowser;
                    $scope.bmlFlags = {
                        bmlFooterShow: true,
                        full: true,
                        xoFooter: true,
                        enableFooter: true,
                        showConfirmationModal: false,
                        showModalBackdrop: true
                    };

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                    $logger.info('TERMSNCONDITIONS_VIEW_RENDER');
                };

                $scope.handleAgreeToTermsClick = function () {
                    this.showConfirmationModal();
                    $logger.info('bmlAgreeToTerms', {});
                };

                $scope.showConfirmationModal = function (show) {
                    show = angular.isUndefined(show) ? true : show;
                    $scope.bmlFlags.showConfirmationModal = show;
                };

                $scope.agreeToTermsConfirmation = function (event) {
                    event.preventDefault();

                    $logger.info('bmlConfirmAgreeToTermsPopup', {});
                    this.showConfirmationModal(false);
                    this.onContinue();
                };

                $scope.cancelApplication = function (event) {
                    event.preventDefault();
                    $logger.info('bmlCancelApplication', {});
                    $scope.bmlStateHandler.payInFullRedirect();
                };

                // when the esc key is pressed
                $('html').on('keyup', function (ev) {
                    if (ev.which === 27) {
                        $scope.showConfirmationModal(false);
                    }
                });

                $scope.onContinue = function () {
                    $logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
                    $scope.bmlStateHandler.applyBML();
                };

                $scope.init();
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js
 ** module id = 479
 ** module chunks = 1
 **/